import { AAROH_IMAGES } from "./images.js";

const IMG = {
  crowd: AAROH_IMAGES.roomWide,
  community: AAROH_IMAGES.studentTeam,
  builders: AAROH_IMAGES.buildSession,
  speaker: AAROH_IMAGES.studentSpeaker,
  makerspace: AAROH_IMAGES.buildSession,
  founders: "/images/grid-photo-09-p8.jpg",
  cohort: AAROH_IMAGES.roomWide,
  aaroh: AAROH_IMAGES.room,
  aurora: "/images/campaign/optimized/grid-campaign-11-aurora-winners.avif",
  flagship: "/images/grid-photo-04-p7.jpg",
};

const route = (path, title, navGroup, pageFamily, description, heroMedia, audience = "all", keywords = []) => ({
  path,
  title,
  navGroup,
  pageFamily,
  audience,
  description,
  keywords: [title, navGroup, pageFamily, ...keywords],
  heroMedia,
  primaryAction: path === "/" ? "Enter the GRID" : "Explore the GRID",
});

export const routeGroups = [
  {
    id: "work",
    label: "Work",
    description: "Programmes, projects and problems young builders can investigate.",
    image: IMG.aaroh,
    links: ["/programmes", "/programmes/aaroh", "/projects", "/problems", "/guides"],
  },
  {
    id: "free-access",
    label: "Free Access",
    description: "Find access routes with cost, eligibility, deadline and status visible.",
    image: IMG.builders,
    links: ["/student-opportunities", "/programmes/upcoming", "/for-students", "/for-schools", "/for-partners", "/get-involved"],
  },
  {
    id: "stories",
    label: "Stories",
    description: "Field notes, media, and the meetings and visits behind GRID.",
    image: IMG.community,
    links: ["/stories", "/media", "/meetings"],
  },
  {
    id: "about",
    label: "About",
    description: "Mission, journey, team, impact, partnerships and governance.",
    image: IMG.founders,
    links: ["/about", "/journey", "/team", "/impact", "/partnerships", "/governance", "/contact"],
  },
];

export const siteRoutes = [
  route("/", "Project GRID", "Work", "Home manifesto", "A youth-built access system for turning real problems into practical work.", IMG.crowd, "all", ["student innovation", "youth-led"]),
  route("/about", "About GRID", "About", "Organisation", "Why GRID exists and how the model works.", IMG.founders),
  route("/journey", "Our journey", "About", "Organisation", "How a student idea became an international innovation ecosystem.", IMG.cohort),
  route("/impact", "Impact", "About", "Organisation", "2,013 participants across AAROH, Aurora and Metamorphosis.", IMG.crowd),
  route("/team", "The team", "About", "Organisation", "The working groups building GRID.", IMG.builders),
  route("/partnerships", "Partnerships", "About", "Organisation", "The organisations behind each programme, and the role each one played.", IMG.community),
  route("/governance", "Governance", "About", "Organisation", "The principles used to design trust, safety and attribution.", IMG.speaker),
  route("/media", "Media library", "Stories", "Directory", "Official GRID photos, clips and logos, with captions.", IMG.crowd),
  route("/meetings", "Meeting archive", "Stories", "Meeting directory", "Meetings and visits connected to GRID. A meeting is not an endorsement.", IMG.community),
  route("/meetings/ajai-chowdhry", "Ajai Chowdhry", "Stories", "Meeting record", "A conversation about innovation and young builders.", "/images/optimized/people-met/DamvNL9yFYV-1080.avif"),
  route("/meetings/ministry-innovation-cell", "Ministry Innovation Cell", "Stories", "Meeting record", "A visit to AICTE and the Ministry of Education's Innovation Cell.", "/images/optimized/people-met/Damu65hSuq4-1080.avif"),
  route("/meetings/sir-ganga-ram-hospital", "Sir Ganga Ram Hospital", "Stories", "Meeting record", "A conversation on youth-led healthcare innovation.", "/images/optimized/people-met/DamurCcyX6R-1080.avif"),
  route("/meetings/cbse-skill-education", "CBSE Skill Education", "Stories", "Meeting record", "A conversation on product development and innovation.", "/images/optimized/people-met/DamuPaKSA0J-1080.avif"),
  route("/meetings/metamorphosis-cohort", "Metamorphosis student cohort", "Stories", "Meeting record", "A week of problem-finding and product building at Metamorphosis.", "/images/optimized/people-met/DamsytGmWmH-1080.avif"),
  route("/programmes", "Programmes", "Work", "Programme directory", "GRID-owned programmes and clearly labelled collaborations.", IMG.aaroh),
  route("/programmes/aaroh", "AAROH", "Work", "Programme story", "A student innovation and entrepreneurship challenge at IIIT Delhi.", IMG.aaroh, "students"),
  route("/programmes/aurora", "Aurora", "Work", "Programme story", "A global changemaking journey designed for broad access.", IMG.aurora, "students"),
  route("/programmes/metamorphosis", "Metamorphosis", "Work", "Programme story", "A programme supported by GRID as outreach partner.", IMG.flagship, "students"),
  route("/programmes/upcoming", "Upcoming events", "Free Access", "Directory", "Confirmed future programme and event announcements.", IMG.speaker),
  route("/student-opportunities", "Free opportunities", "Free Access", "Opportunity directory", "Find access routes with cost, eligibility, deadline and status visible.", IMG.builders),
  route("/student-opportunities/organisations", "Connect as an organisation", "Free Access", "Action pathway", "Bring a problem, place or pathway into the GRID.", IMG.community, "partners"),
  route("/student-opportunities/team", "Join the team", "Free Access", "Action pathway", "Take responsibility for a real part of GRID.", IMG.builders, "contributors"),
  route("/student-opportunities/internships", "Intern with GRID", "Free Access", "Action pathway", "Learn through a scoped contribution with a clear output.", AAROH_IMAGES.studentPortrait, "students"),
  route("/problems", "Problems worth investigating", "Work", "Problem directory", "Real-world challenges young builders can approach responsibly.", IMG.makerspace),
  route("/problems/education", "Education", "Work", "Problem story", "Learning access, participation and classroom-aware tools.", IMG.cohort),
  route("/problems/accessibility", "Accessibility", "Work", "Problem story", "Products and services that exclude through preventable barriers.", AAROH_IMAGES.studentPortrait),
  route("/problems/climate", "Climate", "Work", "Problem story", "Local adaptation, waste, water and environmental decisions.", IMG.makerspace),
  route("/problems/health", "Health", "Work", "Problem story", "Careful community-health design with clear safety boundaries.", IMG.speaker),
  route("/problems/civic-tech", "Civic tech", "Work", "Problem story", "Make public information and participation easier to use.", AAROH_IMAGES.studentPresentation),
  route("/projects", "Student projects", "Work", "Project directory", "Student prototypes, tests and next steps from GRID programmes.", IMG.builders),
  route("/guides", "Guides for young builders", "Work", "Guide directory", "Practical notes for moving from curiosity to a prototype.", AAROH_IMAGES.studentDiscussion),
  route("/guides/find-a-real-world-problem", "Find a real-world problem", "Work", "Field guide", "Move from a broad concern to a specific need.", IMG.community),
  route("/guides/write-a-problem-statement", "Write a problem statement", "Work", "Field guide", "Describe the person, context and constraint clearly.", IMG.speaker),
  route("/guides/beginner-hackathon-guide", "Your first student hackathon", "Work", "Field guide", "A practical guide to teams, scope and presenting.", IMG.builders),
  route("/guides/idea-to-prototype", "From idea to prototype", "Work", "Field guide", "Choose the smallest version that teaches something real.", IMG.makerspace),
  route("/guides/pitch-a-student-project", "Pitch a student project", "Work", "Field guide", "Show the need, evidence, work and next honest step.", AAROH_IMAGES.studentPresentation),
  route("/stories", "Stories and field notes", "Stories", "Story directory", "The rooms and moments behind the work.", IMG.crowd),
  route("/stories/what-is-project-grid", "What is Project GRID?", "Stories", "Field note", "The belief and model behind GRID.", IMG.founders),
  route("/stories/learning-by-building", "Learning by building", "Stories", "Field note", "Notes from the rooms and tools behind the work.", IMG.makerspace),
  route("/for-students", "For students", "Free Access", "Audience pathway", "Find free opportunities, guides and programmes with clear status.", IMG.builders, "students"),
  route(
    "/for-schools",
    "For schools",
    "Free Access",
    "Audience pathway",
    "Bring a GRID activity to your students and see what a school collaboration involves.",
    IMG.cohort,
    "schools",
    ["school collaboration", "school access", "teacher-led activity"],
  ),
  route("/for-partners", "For partners", "Free Access", "Audience pathway", "Bring real problems, mentoring and pathways into the room.", IMG.community, "partners"),
  route("/get-involved", "Join GRID", "Free Access", "Action pathway", "Choose how you want to take part: as a student, a school, a mentor or a team member.", IMG.crowd),
  route("/contact", "Contact GRID", "About", "Action pathway", "Start with a clear note about what you want to make possible.", AAROH_IMAGES.studentTeam),
  route("/privacy", "Privacy", "About", "Legal", "How GRID handles information submitted through the site.", IMG.makerspace),
  route("/terms", "Terms", "About", "Legal", "Terms for using GRID's public information and resources.", IMG.speaker),
];

export const sitemapPaths = siteRoutes.map((item) => item.path);

export function findRoute(pathname) {
  return siteRoutes.find((item) => item.path === pathname) ?? null;
}

export function relatedRoutesFor(pathname, limit = 3) {
  const current = findRoute(pathname);
  if (!current) return [];
  return siteRoutes
    .filter((item) => item.path !== pathname && item.navGroup === current.navGroup && item.pageFamily !== "Legal")
    .slice(0, limit);
}

export function routeLabel(pathname) {
  return findRoute(pathname)?.title ?? pathname.split("/").filter(Boolean).at(-1)?.replaceAll("-", " ") ?? "Project GRID";
}
